import Header from "../components/Header";
import About from "../components/About";
import Footer from "../components/Footer";

import "./styles.css"

export default function ContactUs() {
  return (
    <div className="AboutUs">
      <Header></Header>
      <About></About>
      <Footer></Footer>
    </div>
  );
}
